















import mixins from 'vue-typed-mixins';
import _ from 'lodash';
import { editName } from '@/main/store/listEditTypes';
import { EventBus } from '@/main/eventBus';

import { Tabs } from '../../components';
import EditLayout from '../../EditLayout.vue';
import WorkflowButtons from '../../components/WorkflowButtons.vue';
import { EditMixin } from '../../mixins/editMixin';
import { NAME } from './constants';
import HlavniKarta from './HlavniKarta.vue';
import InterniKarta from './InterniKarta.vue';
import { MENU_CODE, TAB_NAMES, TABS, ZAKAZKA_DRUH } from '../../constants';
import { UserRole } from '@/main/components/constants';

export default mixins(EditMixin).extend({
	name: editName(NAME),
	components: {
		HlavniKarta,
		EditLayout,
		Tabs,
		WorkflowButtons,
		InterniKarta,
	},
	computed: {
		isUserServiceAdvisorOrCre(): boolean {
			return this.pracovnik.PracovnikOzn === (UserRole.SERVICE_ADVISER) || this.pracovnik.PracovnikOzn === (UserRole.CRE);
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(MENU_CODE, TABS.AddvancePay)) tabItems.push(TAB_NAMES.ADVANCEPAY);
			if (this.hasTabAccess(MENU_CODE, TABS.ND)) tabItems.push(TAB_NAMES.ND);
			if (this.hasTabAccess(MENU_CODE, TABS.Vydejky)) tabItems.push(TAB_NAMES.VYDEJKY);
			if (this.hasTabAccess(MENU_CODE, TABS.History)) tabItems.push(TAB_NAMES.HISTORY);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamky)) tabItems.push(TAB_NAMES.POZNAMKY);
			if (this.hasTabAccess(MENU_CODE, TABS.Zarazeni)) tabItems.push(TAB_NAMES.ZARAZENI);
			if (this.hasTabAccess(MENU_CODE, TABS.ZakazkyRef)) tabItems.push(TAB_NAMES.ZAKAZKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.OSC)) tabItems.push(TAB_NAMES.ZAKAZKY_OSC);

			return _.pick(TABS, tabItems);
		},
		isInternalPanelVisible(): boolean {
			return this.ZakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND;
		},
	},
	watch: {
		isZakazkaDisabled(isDisabled) {
			if (isDisabled) {
				EventBus.$emit('DisableAll', true);
			}
		},
	},
});
